import React, { useState, useEffect } from "react";
import {
  Navigation,
  Page,
  TaskExternal,
  Storage,
  ModalFeedback,
  TaskTabPanel,
  Button,
} from "@bittnerdevelopmentgroup/interactive";

import "./styles.css"


const PrisonerDilemmaCell = (props) => {
  return (
    <div
      style={{
        minHeight: "150px",
        position: "relative",
      }}
      aria-label={props.ariaLabel}
      aria-live={props.ariaLive}
    >
      <span aria-hidden="true">
        <span
          style={{ float: "right" }}
          className="p1"
          hidden={props.hidden}
        >
          {props.text1}
        </span>
        <span
          style={{
            float: "left",
            position: "absolute",
            bottom: 0,
            left: 0,
          }}
          className="p2"
          hidden={props.hidden}
        >
          {props.text2}
        </span>
      </span>
    </div>
  )
}
const PrisonerDilemma = (props) => {
  return (
    <>
      <div><b>The Prisoner's Dilemma</b></div>
      <table
        className="prisoners-dilemma-table"
        id="prisoners-dilemma"
        aria-label={props.ariaLabel || "A 2 by 2 payoff matrix shows the outcomes of the Prisoner's Dilemma. There are two suspects, Tony Montana and Manny Ribera. In the top left corner, if both suspects testify against each other, they each get 10 years in jail. In the top right corner, if Tony Montana keeps quiet and Manny Ribera testifies, Tony Montana gets 25 years in jail while Manny Ribera goes free. In the bottom left corner, if Tony Montana testifies and Manny Ribera keeps quiet, Tony Montana goes free while Manny Ribera gets 25 years in jail. In the bottom right corner, if both suspects keep quiet, they both get one year in jail."}
        aria-describedby={props.ariaDescribedBy}
      >
        <tbody>
          <tr align="center" className="no-border">
            <td colSpan="2" rowSpan="2" className="outerCell no-border" aria-hidden="true"></td>
            <td colSpan="2" className="p1 outerCell no-border">Tony Montana</td>
          </tr>
          <tr align="center" className="no-border">
            <td style={{ width: "30.75%" }} className="p1 outerCell">{props.p1[0]}</td>
            <td style={{ width: "30.75%" }} className="p1 outerCell">{props.p1[1]}</td>
          </tr>
          <tr align="right" className="no-border">
            <td
              colSpan="1" rowSpan="2"
              style={{ width: "15%", textAlign: "left" }}
              className="p2 outerCell"
            >
              Manny Ribera
            </td>
            <td style={{ width: "24.5%" }} className="p2 outerCell">{props.p2[0]}</td>
            <td className="innerCell">
              <PrisonerDilemmaCell
                hidden={props.hidden[0]}
                ariaLabel={props.hidden[0] ? undefined : 'Both Manny Ribera and Tony Montana receive 10 years in jail.'}
                ariaLive="polite"
                text1="10 years in jail"
                text2="10 years in jail"
              />
            </td>
            <td className="innerCell">
              <PrisonerDilemmaCell
                hidden={props.hidden[1]}
                ariaLabel={props.hidden[1] ? undefined : 'Tony Montana receives 25 years in jail while Manny Ribera goes free.'}
                ariaLive="polite"
                text1="25 years in jail"
                text2="goes free"
              />
            </td>
          </tr>
          <tr align="right" className="no-border">
            <td className="p2 outerCell">{props.p2[1]}</td>
            <td className="innerCell">
              <PrisonerDilemmaCell
                hidden={props.hidden[2]}
                ariaLabel={props.hidden[2] ? undefined : 'Tony Montana goes free while Manny Ribera receives 25 years in jail.'}
                ariaLive="polite"
                text1="goes free"
                text2="25 years in jail"
              />
            </td>
            <td className="innerCell">
              <PrisonerDilemmaCell
                hidden={props.hidden[3]}
                ariaLabel={props.hidden[3] ? undefined : 'Both Manny Ribera and Tony Montana receive 1 year in jail.'}
                ariaLive="polite"
                text1="1 year in jail"
                text2="1 year in jail"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

const PrisonerDilemmaQuestion = (props) => {

  const [state, setState] = useState(props.state || {})

  useEffect(() => {
    let newState = state
    if (!newState.initialized) {
      newState.initialized = true
      props.setComplete(false)
      props.setModal(false)
      props.setClickedIncorrect(false)
      setState(state)
    }
  }, [props, state])

  return <>
    <PrisonerDilemma
      hidden={false}
      p1={props.p1 ? ["Testify", "Keep Quiet"] : [
        <div style={{ minHeight: "48px" }}>
          <Button
            className={props.complete ? 'nds-button-disabled' : undefined}
            variant={props.complete ? 'solid' : 'outline'}
            color={props.complete ? 'success' : 'base'}
            onClick={() => {
              if (props.complete) return
              props.setComplete(true)
              props.setModal(true)
            }}
            aria-disabled={props.complete}
            aria-label={props.complete ? 'Correct: Testify' : undefined}
          >
            Testify
          </Button>
        </div>,
        <div style={{ minHeight: "48px" }}>
          <Button
            className={(props.clickedIncorrect || props.complete) ? 'nds-button-disabled' : undefined}
            variant={(props.clickedIncorrect || props.complete) ? 'solid' : 'outline'}
            color={(props.clickedIncorrect || props.complete) ? 'error' : 'base'}
            onClick={() => {
              if (props.clickedIncorrect || props.complete) return
              props.setModal(true)
              props.setClickedIncorrect(true)
            }}
            aria-disabled={props.clickedIncorrect || props.complete}
            aria-label={props.complete ? 'Incorrect: Keep Quiet' : undefined}
          >
            Keep Quiet
          </Button>
        </div>
      ]}
      p2={props.p1 ? [
        <Button
          className={props.complete ? 'nds-button-disabled' : undefined}
          variant={props.complete ? 'solid' : 'outline'}
          color={props.complete ? 'success' : 'base'}
          onClick={() => {
            if (props.complete) return
            props.setModal(true)
            props.setComplete(true)
          }}
          aria-disabled={props.complete}
          aria-label={props.complete ? 'Correct: Testify' : undefined}
        >
          Testify
        </Button>,
        <Button
          className={(props.clickedIncorrect || props.complete) ? 'nds-button-disabled' : undefined}
          variant={(props.clickedIncorrect || props.complete) ? 'solid' : 'outline'}
          color={(props.clickedIncorrect || props.complete) ? 'error' : 'base'}
          onClick={() => {
            if (props.clickedIncorrect || props.complete) return
            props.setModal(true)
            props.setClickedIncorrect(true)
          }}
          aria-disabled={props.clickedIncorrect || props.complete}
          aria-label={props.complete ? 'Incorrect: Keep Quiet' : undefined}
        >
          Keep Quiet
        </Button>
      ] : ["Testify", "Keep Quiet"]}
    />
    <ModalFeedback
      noRetry={props.complete}
      correct={props.complete}
      show={props.modal}
      onHide={() => props.setModal(false)}
    >
      {
        props.p1 &&
        <>
          {!props.complete && <p>Remember that if Tony testifies and Manny keeps quiet, Manny will receive a 25-year jail sentence. Is there another option that will lead to less jail time?</p>}
          {props.complete && <p>In fact, no matter what Tony does, the smartest thing for Manny to do is to testify. Because Manny will always prefer that strategy, regardless of what Tony chooses, testifying is called his <b>dominant strategy</b>.</p>}
        </>
      }
      {
        props.p2 &&
        <>
          {!props.complete && <p>If Manny keeps quiet and Tony keeps quiet, Tony will receive a 1-year jail sentence. Is there another option that will lead to less jail time?</p>}
          {props.complete && <p>In fact, testifying is also Tony’s dominant strategy, because it’s the smartest thing for him to do no matter what Manny chooses. Because both suspects have a dominant strategy, this situation is a <b>Nash equilibrium</b>, in which all economic decision-makers have no incentive to change their current decision.</p>}
        </>
      }
    </ModalFeedback>
    <TaskExternal state={Storage()} completed={props.complete} />
  </>
}

const StrategicBehavior = () => {

  const [complete2, setComplete2] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [clickedIncorrect2, setClickedIncorrect2] = useState(false)

  const [complete3, setComplete3] = useState(false)
  const [modal3, setModal3] = useState(false)
  const [clickedIncorrect3, setClickedIncorrect3] = useState(false)

  return (
    <div className="strategicBehavior">
      <Navigation interactiveId="chapter-13">
        <Page>
          <p>
            The following is an example of a fundamental problem in game theory called the prisoner’s dilemma. 
            This payoff matrix shows the outcome for each suspect if they decide to (a) testify or (b) keep quiet.
          </p>
          <p>
            In this scenario, consider the two main characters from the 1983 film <em>Scarface</em>: Manny Ribera and Tony 
            Montana. Each must decide whether to cooperate with the authorities by testifying or remain silent, 
            without knowing what the other will choose.
          </p>
          <p>
            <i>Explore each tab to learn about the consequences of every possible set of choices. In the next steps, 
            you will choose the best decision for both Tony and Manny: testify or keep quiet?</i>
          </p>
          <TaskTabPanel
            state={Storage()}
            label="Cat pictures"
            contents={[
              {
                title: "Both testify.",
                contents: (
                  <PrisonerDilemma
                    ariaLabel="A 2 by 2 payoff matrix shows the outcomes of the Prisoner's Dilemma. There are two suspects, Tony Montana and Manny Ribera. In the top left corner, if both suspects testify against each other, they each get 10 years in jail."
                    hidden={[false, true, true, true]}
                    p1={["Testify", "Keep Quiet"]}
                    p2={["Testify", "Keep Quiet"]}
                  />
                ),
              },
              {
                title: "Both keep quiet.",
                contents: (
                  <PrisonerDilemma
                    ariaLabel="A 2 by 2 payoff matrix shows the outcomes of the Prisoner's Dilemma. There are two suspects, Tony Montana and Manny Ribera. In the bottom right corner, if both suspects keep quiet, they both get one year in jail."
                    hidden={[true, true, true, false]}
                    p1={["Testify", "Keep Quiet"]}
                    p2={["Testify", "Keep Quiet"]}
                  />
                ),
              },
              {
                title: "Tony testifies. / Manny keeps quiet.",
                contents: (
                  <PrisonerDilemma
                    ariaLabel="A 2 by 2 payoff matrix shows the outcomes of the Prisoner's Dilemma. There are two suspects, Tony Montana and Manny Ribera. In the bottom left corner, if Tony Montana testifies and Manny Ribera keeps quiet, Tony Montana goes free while Manny Ribera gets 25 years in jail."
                    hidden={[true, true, false, true]}
                    p1={["Testify", "Keep Quiet"]}
                    p2={["Testify", "Keep Quiet"]}
                  />
                ),
              },
              {
                title: "Manny testifies. / Tony keeps quiet.",
                contents: (
                  <PrisonerDilemma
                    ariaLabel="A 2 by 2 payoff matrix shows the outcomes of the Prisoner's Dilemma. There are two suspects, Tony Montana and Manny Ribera. In the top right corner, if Tony Montana keeps quiet and Manny Ribera testifies, Tony Montana gets 25 years in jail while Manny Ribera goes free."
                    hidden={[true, false, true, true]}
                    p1={["Testify", "Keep Quiet"]}
                    p2={["Testify", "Keep Quiet"]}
                  />
                ),
              },
            ]}
          />
        </Page>
        <Page>
          <p>
            Manny thinks that Tony will testify. <b>If Tony testifies, which course of action would result in Manny getting the least amount of jail time?</b>
          </p>
          <p>
            <i>Select the button that corresponds to the best choice for Manny.</i>
          </p>
          <PrisonerDilemmaQuestion
            state={Storage()}
            p1={true}
            complete={complete2}
            setComplete={setComplete2}
            modal={modal2}
            setModal={setModal2}
            clickedIncorrect={clickedIncorrect2}
            setClickedIncorrect={setClickedIncorrect2}
          />
        </Page>
        <Page>
          <p>
            Tony thinks that Manny will keep quiet. <b>If Manny keeps quiet, which course of action would result in Tony getting the least amount of jail time?</b>
          </p>
          <p>
            <i>Select the button that corresponds to the best choice for Tony.</i>
          </p>
          <PrisonerDilemmaQuestion
            state={Storage()}
            p2={true}
            complete={complete3}
            setComplete={setComplete3}
            modal={modal3}
            setModal={setModal3}
            clickedIncorrect={clickedIncorrect3}
            setClickedIncorrect={setClickedIncorrect3}
          />
        </Page>
      </Navigation>
    </div>
  )
}

export default StrategicBehavior
